import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["limit", "value", "warningLimit"];
import { ProgressBar } from './ProgressBar';
import { getOverLimit, getPercentage } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgressBarLimits = _ref => {
  let {
      limit,
      value,
      warningLimit = 80
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const percentage = getPercentage({
    value,
    limit
  });
  const isOverLimit = getOverLimit({
    value,
    limit
  });
  let variant = 'success';
  if (isOverLimit) {
    variant = 'danger';
  } else if (percentage >= warningLimit) {
    variant = 'warning';
  }
  return /*#__PURE__*/_jsx(ProgressBar, Object.assign({}, rest, {
    limit: limit,
    value: value,
    variant: variant
  }));
};
ProgressBarLimits.Percentage = ProgressBar.Percentage;